/**
 * React Router resolves `to="#"` / `to="/#"` with an undefined pathname and can throw
 * (e.g. "Cannot read properties of undefined (reading 'endsWith')") on re-render.
 */
export function safeRouterTo(link: string | undefined | null): string {
  if (!link) {
    return "/";
  }
  const trimmed = link.trim();
  if (
    trimmed === "#" ||
    trimmed === "#!" ||
    trimmed === "/#" ||
    trimmed === "/#!"
  ) {
    return "/";
  }
  return trimmed;
}
